__turbopack_context__.v({
  "price-curve-wrapper": "bkdLLa_price-curve-wrapper",
});
